import React, { useEffect, useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import beforeImage from '../assets/before-image.png';
import afterImage from '../assets/after-image.png';



// NEW REVAMPED PAGE STYLES
const pageContainerStyle = {
  width: '100%',
  minHeight: '100vh',
  background: '#fff'
};

const sectionOneStyle = {
  padding: '140px 20px 60px 20px',
  textAlign: 'center',
  background: 'linear-gradient(135deg, #2AF598 0%, #08B3E5 100%)'
};

const mainHeaderStyle = {
  fontSize: '4.2rem',
  fontWeight: '700',
  color: '#ffffff',
  marginBottom: '60px',
  lineHeight: '1.2',
  maxWidth: '1200px',
  margin: '40px auto 60px auto',
  textShadow: '0 4px 24px rgba(0,0,0,0.12), 0 1.5px 6px rgba(0,0,0,0.10)'
};

const imagesContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  gap: '60px',
  maxWidth: '1600px',
  margin: '0 auto',
  flexWrap: 'wrap'
};

const imageBoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '700px'
};

const imageStyle = {
  width: '700px',
  height: '500px',
  borderRadius: '12px 12px 0 0',
  marginBottom: '0',
  objectFit: 'cover',
  boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
};

const imageTextBoxStyle = {
  background: '#fff',
  padding: '25px',
  borderRadius: '0 0 12px 12px',
  boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
  width: '700px',
  textAlign: 'center'
};

const sectionTwoStyle = {
  padding: '80px 20px',
  background: '#fff',
  position: 'relative'
};

const dividerLineStyle = {
  position: 'absolute',
  left: '50%',
  top: '0',
  bottom: '0',
  width: '4px',
  background: '#2c2c2c',
  transform: 'translateX(-50%)'
};

const twoColumnContainerStyle = {
  display: 'flex',
  maxWidth: '1480px',
  margin: '0 auto',
  gap: '80px',
  alignItems: 'flex-start'
};

const columnStyle = {
  width: '700px',
  padding: '0 40px'
};

const columnHeaderStyle = {
  fontSize: '2.2rem',
  fontWeight: '700',
  marginBottom: '30px',
  textAlign: 'center'
};

const leftColumnHeaderStyle = {
  ...columnHeaderStyle,
  color: '#d63384'
};

const rightColumnHeaderStyle = {
  ...columnHeaderStyle,
  color: '#2AF598'
};

const columnTextStyle = {
  fontSize: '1.1rem',
  lineHeight: '1.7',
  color: '#495057'
};

const bulletPointStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '15px'
};

const bulletIconStyle = {
  marginRight: '12px',
  marginTop: '4px',
  fontSize: '1.2rem'
};

const sectionThreeStyle = {
  padding: '80px 20px',
  background: '#f0fffa',
  textAlign: 'center',
  color: '#3d3479'
};

const finalHeaderStyle = {
  fontSize: '2.8rem',
  fontWeight: '400',
  marginBottom: '30px',
  maxWidth: '800px',
  margin: '0 auto 30px auto',
  color: '#045C5C'
};

const finalButtonStyle = {
  background: 'linear-gradient(135deg, #2AF598 0%, #08B3E5 100%)',
  color: 'white',
  border: 'none',
  padding: '18px 40px',
  borderRadius: '8px',
  fontSize: '1.3rem',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textDecoration: 'none',
  display: 'inline-block',
  marginTop: '20px'
};

// Rotating word carousel styles
const rotatingContainerStyle = {
  position: 'relative',
  display: 'block',
  width: '100%',
  maxWidth: '1200px',
  // minWidth: '1100px',
  height: '1.4em',
  overflow: 'hidden',
  borderRadius: '8px',
  padding: '0.1em 0.3em',
  marginTop: '0.7em',
  margin: '0.7em auto 0 auto',
};

const centeredArrowContainerStyle = {
  position: 'absolute',
  left: '0',
  right: '0em',
  top: '0.7em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap'
};

const beforeWordStyle = {
  position: 'absolute',
  right: '50%',
  marginRight: '1.5em',
  whiteSpace: 'nowrap',
  textAlign: 'right'
};

const arrowStyle = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '1em',
  whiteSpace: 'nowrap',
  zIndex: 10
};

const afterWordStyle = {
  position: 'absolute',
  left: '50%',
  marginLeft: '1.5em',
  whiteSpace: 'nowrap',
  textAlign: 'left'
};

function Features() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Rotating word pair state
  const [wordPairIndex, setWordPairIndex] = useState(0);
  const wordPairs = useMemo(() => [
    { before: 'chaos', after: 'success' },
    { before: 'overwhelmed', after: 'organized' },
    { before: 'struggling', after: 'thriving' },
    { before: 'burnout', after: 'balance' },
    { before: 'scattered', after: 'streamlined' }
  ], []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setWordPairIndex((prev) => (prev === wordPairs.length - 1 ? 0 : prev + 1));
    }, 2500);
    return () => clearTimeout(timer);
  }, [wordPairIndex, wordPairs.length]);

  const handlePricingClick = () => {
    // Navigate to home page pricing section
    window.location.href = '/#pricing';
  };

  return (
    <div style={pageContainerStyle}>
      {/* Section 1: Header and Before/After Images */}
      <section id="home" style={sectionOneStyle}>
        <h1 style={mainHeaderStyle}>
          This is the assistant that will take you from{' '}
          <span style={rotatingContainerStyle}>
            <div style={centeredArrowContainerStyle}>
              {/* Before words */}
              {wordPairs.map((wordPair, index) => (
                <motion.span
                  key={`before-${index}`}
                  style={beforeWordStyle}
                  initial={{ opacity: 0, y: '-100%' }}
                  animate={
                    wordPairIndex === index
                      ? { opacity: 1, y: '0%' }
                      : wordPairIndex > index
                      ? { opacity: 0, y: '-150%' }
                      : { opacity: 0, y: '150%' }
                  }
                  transition={{ type: 'spring', stiffness: 50 }}
                >
                  {wordPair.before}
                </motion.span>
              ))}
              
              {/* Fixed arrow in center */}
              <span style={arrowStyle}>→</span>
              
              {/* After words */}
              {wordPairs.map((wordPair, index) => (
                <motion.span
                  key={`after-${index}`}
                  style={afterWordStyle}
                  initial={{ opacity: 0, y: '-100%' }}
                  animate={
                    wordPairIndex === index
                      ? { opacity: 1, y: '0%' }
                      : wordPairIndex > index
                      ? { opacity: 0, y: '-150%' }
                      : { opacity: 0, y: '150%' }
                  }
                  transition={{ type: 'spring', stiffness: 50 }}
                >
                  {wordPair.after}
                </motion.span>
              ))}
            </div>
          </span>
        </h1>
        
        <div style={imagesContainerStyle}>
          <div style={imageBoxStyle}>
            <img 
              src={beforeImage} 
              alt="Before - The Struggling Teacher" 
              style={imageStyle}
            />
            <div style={imageTextBoxStyle}>
              <h3 style={{color: '#045C5C', marginBottom: '15px', fontSize: '1.3rem'}}>
                Does This Look Familiar?
              </h3>
              <p style={{margin: 0, color: '#6c757d'}}>
              Juggling sticky notes, handwritten schedules, and last-minute changes. It's a lot to manage on top of teaching.
              </p>
            </div>
          </div>

          <div style={imageBoxStyle}>
            <img 
              src={afterImage} 
              alt="After - The Empowered Teacher" 
              style={imageStyle}
            />
            <div style={imageTextBoxStyle}>
              <h3 style={{color: '#045C5C', marginBottom: '15px', fontSize: '1.3rem'}}>
                Imagine This Instead
              </h3>
              <p style={{margin: 0, color: '#6c757d'}}>
              A single, clear view of your schedule that automatically manages your bookings, maximizes your income, and gives you peace of mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Comparison with Vertical Divider */}
      <section style={sectionTwoStyle}>
        <div style={dividerLineStyle}></div>
        
        <div style={twoColumnContainerStyle}>
          <div style={columnStyle}>
            <h2 style={leftColumnHeaderStyle}>The Common Challenges of Running a Studio</h2>
            <div style={columnTextStyle}>
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#d63384', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>The Time Drain & Teacher Burnout</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Studies show teachers can work over 50 hours a week, with less than half that time spent on actual teaching. This relentless cycle of administrative tasks encroaching on personal time is why nearly half of all music teachers consider leaving the profession within 5 years. The passion that started it all gets buried under paperwork.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#d63384', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>Unpredictable Income & Policy Headaches</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Lost income from no-shows and last-minute cancellations directly impacts your financial stability. Managing make-up lessons becomes a "symphony of administrative headaches," and enforcing cancellation policies often leads to awkward conversations and strained relationships with students and parents.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#d63384', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>Manual Friction & Stalled Growth</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>When your studio runs on sticky notes, spreadsheets, and memory, it's hard to present a polished image or even think about growth. Capturing new students is a manual, often slow process, meaning you miss opportunities. The entire system feels fragile and difficult to scale.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#d63384', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>The Impossible Rescheduling Puzzle</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>A single request to change a lesson time can trigger a cascade of emails and texts, trying to align your availability with the student's, all while tracking your studio's make-up policies. This frustrating logistical puzzle eats up valuable time and mental energy for everyone involved.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#d63384', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>A Fractured Client Experience</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>When communication is scattered across texts, emails, and phone calls, it creates confusion and frustration for students and parents. A disjointed administrative process can undermine your professionalism, damage client relationships, and negatively impact student retention.</p>
              </div>
            </div>
          </div>

          <div style={columnStyle}>
            <h2 style={rightColumnHeaderStyle}>The MusicTeachers.ai Solution</h2>
            <div style={columnTextStyle}>
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#2AF598', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>Automate Your Admin, Reclaim Your Passion</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Our AI-powered assistant works 24/7, handling inquiries, coordinating schedules, and sending reminders automatically. We turn hours of tedious back-and-forth emails and phone calls into minutes of simple oversight, giving you the work-life balance you deserve and freeing you to focus on what you love—teaching music.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#2AF598', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>Stabilize Your Income, Eliminate No-Shows</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Drastically reduce no-shows by up to 90% with smart, automated reminders. Our platform allows you to clearly communicate and effortlessly enforce your policies during booking, creating a predictable revenue stream. Maximize your income by optimizing your schedule, not just by chasing payments.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#2AF598', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>Streamline Operations, Grow Effortlessly</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Our platform provides a single, professional online presence that differentiates you from the competition. Capture new students even while you sleep with 24/7 booking capabilities. With a system that handles the details, you can scale your studio and take on more students without increasing your working hours.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#2AF598', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>Intelligent, Automated Rescheduling</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Set your rules once (e.g., "students can reschedule up to 24 hours in advance"), and let the platform do the work. Students see your actual availability and can reschedule themselves with a click. This ends the negotiation process and ensures your policies are followed perfectly every time, without you lifting a finger.</p>
              </div>
              
              <div style={{marginBottom: '2.5em'}}>
                <h4 style={{color: '#2AF598', fontWeight: '600', marginBottom: '0.8em', fontSize: '1.2rem'}}>A Centralized, Professional Hub</h4>
                <p style={{margin: '0', lineHeight: '1.6'}}>Provide a seamless experience with a single, polished portal for your clients. They can view your availability, book lessons, see policies, and manage their schedule—all in one place. This builds trust, communicates your value, and creates the five-star experience that keeps students coming back.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Call to Action */}
      <section style={sectionThreeStyle}>
        <h2 style={finalHeaderStyle}>
          Ready to Transform Your Music Teaching Business?
        </h2>
        <p style={{fontSize: '1.2rem', marginBottom: '30px', color: '#6c757d'}}>
          Join thousands of music teachers who have already made the switch to automated success
        </p>
        <button 
          style={finalButtonStyle}
          onClick={handlePricingClick}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          View Pricing Plans
        </button>
      </section>
    </div>
  );
}



export default Features; 